import Rendable from '@/glxp/abstract/rendable'
import Shader from '@/glxp/utils/shader'

import ShaderManifest from '../entities/shaderManifest'
import Settings from '@/glxp/settings'

const VERTICES = [-1, 1, 0,
  -1, -1, 0,
  1, -1, 0,
  1, 1, 0]
const INDICES = [0, 1, 2, 0, 2, 3]
const UVS = [
  0, 0,
  0, 1,
  1, 1,
  1, 0
]

class Background extends Rendable {
  constructor (scene, rect) {
    super(scene)
    this.hasNormal = true
    var shader = new Shader(ShaderManifest['image-transition'])
    this.initProgram(shader.vert, shader.frag)

    this.initBuffer({
      vertices: this.getGlRect(this.getCoverRect()),
      uvs: UVS,
      normal: this.getGlRect(rect),
      indices: INDICES
    })

    this.progress = 0
    this.imgSizeX = 0
    this.imgSizeY = 0
    this.alpha = 0

    this.initVao()
    this.createUniforms()
  }

  getCoverRect () {
    let bounds = document.querySelector('.transition-cover-helper').getBoundingClientRect()
    let rect = [
      bounds.left / (this.scene.width / this.scene.dpr),
      bounds.top / (this.scene.height / this.scene.dpr),
      bounds.width / (this.scene.width / this.scene.dpr),
      bounds.height / (this.scene.height / this.scene.dpr)
    ]
    return rect
  }

  getGlRect (rect) {
    return [
      rect[0], rect[1], 0,
      rect[0], rect[1] + rect[3], 0,
      rect[0] + rect[2], rect[1] + rect[3], 0,
      rect[0] + rect[2], rect[1], 0
    ]
  }

  createUniforms () {
    this.createUniform('uTexture', 'texture')
    this.createUniform('uRez', 'float2')
    this.createUniform('uAlpha')
    this.createUniform('uImgRez', 'float2')
    this.createUniform('uProgress')
    this.createUniform('uOverlay')
  }

  applyState () {
    let gl = this.gl
    this.scene.applyDefaultState()
    gl.disable(gl.DEPTH_TEST)
    // gl.disable(gl.BLEND)
  }

  scaleWithMargin (vertices) {
    let v = vertices.slice(0)
    let height = this.scene.height
    let margin = this.scene.marginBottom
    let m = margin / height
    v[4] += m * 2
    v[7] += m * 2
    return v
  }

  kill () {
    this.alpha = 0
    this.scene.textureLoader.getImage('image-transition').width = 0
    this.scene.textureLoader.getImage('image-transition').height = 0

    this.killRender()
    this.gl.deleteTexture(this.scene.textureLoader.getTexture('image-transition'))
    // this.gl.deleteBuffer(this.customAttributes[0].buffer)
    this.gl.deleteBuffer(this.vertexPositionBuffer)
    this.gl.deleteBuffer(this.uvsBuffer)
    this.gl.deleteVertexArray(this.vao)
    this.gl.deleteShader(this.vertShader)
    this.gl.deleteShader(this.fragSahder)
    this.gl.deleteProgram(this.program)
  }

  render () {
    let gl = this.gl
    gl.useProgram(this.program)
    gl.bindVertexArray(this.vao)
    this.applyState()
    gl.activeTexture(gl.TEXTURE0)
    gl.bindTexture(gl.TEXTURE_2D, this.scene.textureLoader.getTexture('image-transition'))
    this.bindUniform('uTexture', 0)
    let texture = this.scene.textureLoader.getImage('image-transition')
    this.bindUniform('uImgRez', [texture.width, texture.height])

    this.bindUniform('uRez', [this.imgSizeX, this.imgSizeY])
    this.bindUniform('uAlpha', this.alpha)
    this.bindUniform('uProgress', this.progress)
    this.bindUniform('uOverlay', Settings.overlay_cover.value)

    // this.tl.progress(this.scene.step)
    // this.bindUniform("uColor", )

    gl.drawElements(gl.TRIANGLES, INDICES.length, gl.UNSIGNED_SHORT, 0)
    gl.bindVertexArray(null)
  }

  killRender () {
    let gl = this.gl
    this.bindUniform('uAlpha', 0)
    this.bindUniform('uImgRez', [0, 0])
    gl.drawElements(gl.TRIANGLES, INDICES.length, gl.UNSIGNED_SHORT, 0)
    gl.bindVertexArray(null)
  }
}

export default Background
